import { render, staticRenderFns } from "./edit_goods.vue?vue&type=template&id=790bbb62&scoped=true"
import script from "./edit_goods.vue?vue&type=script&lang=js"
export * from "./edit_goods.vue?vue&type=script&lang=js"
import style0 from "./edit_goods.vue?vue&type=style&index=0&id=790bbb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790bbb62",
  null
  
)

export default component.exports